import { useState } from 'react';
import { useT } from '@hana/i18n';
import s from './bodDock.module.css';
import './i18n';

// Bảng phải của Mint-BOD-1920 (Chờ duyệt · Ghi chú dữ liệu). Dữ liệu mẫu của board; chỉ đếm, không tiền.

type DockTab = 'wait' | 'note';
type Item = { k: string; s: string; c: string };
type Sec = { k: string; s: string; items: Item[]; link?: string };

const BLUE = 'var(--d-blue)';
const AMBER = 'var(--d-amber)';
type T = (k: string, v?: Record<string, string | number>) => string;
const secs = (t: T): Record<DockTab, Sec[]> => ({
  wait: [
    { k: t('bod.dk.w1'), s: t('bod.dk.w1s'), items: [{ k: t('bod.dk.w1i'), s: 'ThuyNTT · SE261040115', c: BLUE }] },
    { k: t('bod.dk.w2'), s: t('bod.dk.w2s'), items: [{ k: t('bod.dk.w2i'), s: t('bod.dk.w2is'), c: AMBER }], link: t('bod.dk.w2l') },
    { k: 'KPI', s: t('bod.dk.w3s'), items: [{ k: t('bod.dk.w3i'), s: t('bod.dk.w3is'), c: 'var(--ok)' }], link: t('bod.dk.w3l') },
  ],
  note: [
    {
      k: t('bod.dk.n0'),
      s: t('bod.dk.n0s'),
      items: [
        { k: t('bod.dk.n1'), s: t('bod.dk.n1s'), c: AMBER },
        { k: t('bod.dk.n2'), s: t('bod.dk.n2s'), c: BLUE },
        { k: t('bod.dk.n3'), s: t('bod.dk.n3s'), c: BLUE },
        { k: t('bod.dk.n4'), s: t('bod.dk.n4s'), c: BLUE },
      ],
    },
  ],
});

export function BodDock({ onClose, onNote }: { onClose: () => void; onNote: (msg: string) => void }) {
  const t = useT();
  const [tab, setTab] = useState<DockTab>('wait');
  const tabs: Array<[DockTab, string]> = [['wait', t('bod.dock.wait')], ['note', t('bod.dock.note')]];
  return (
    <div className={s.dock} aria-label={t('bod.dock')}>
      <div className={s.head}>
        <div role="tablist" aria-label={t('bod.dock')} className={s.tabs}>
          {tabs.map(([k, l]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} className={`${s.tab} ${tab === k ? s.on : ''}`} onClick={() => setTab(k)}>{l}</button>
          ))}
        </div>
        <button type="button" className={s.close} aria-label={t('bod.dockClose')} onClick={onClose}>×</button>
      </div>
      {secs(t)[tab].map((sec) => (
        <section key={sec.k} className={s.sec}>
          <h2>{sec.k}</h2>
          <div className={s.sub}>{sec.s}</div>
          {sec.items.map((n, i) => (
            <button key={n.k} type="button" className={`${s.item} ${i === 0 ? s.first : ''}`} onClick={() => onNote(t('bod.later'))}>
              <span className={s.dot} style={{ background: n.c }} />
              <span><b>{n.k}</b><small>{n.s}</small></span>
            </button>
          ))}
          {sec.link && <button type="button" className={s.link} onClick={() => onNote(t('bod.later'))}>{sec.link}</button>}
        </section>
      ))}
    </div>
  );
}
